import { useEffect } from 'react';

// Overlay back registry (pre-TestFlight QA line, 2026-09-16 — Android native-shell QA matrix B).
//
// Every overlay already has an explicit way out (OC §9.4: the header Close, the backdrop, Escape).
// A hardware / system Back press is one more way out of the SAME overlay, never a navigation step
// underneath it: on Android the system Back must close the topmost sheet, confirm, drawer or
// lightbox first, and only unwind the screen stack when nothing is open. Overlays register their
// close callback here while mounted (most recent last); the native shell asks the registry first.
//
// Nothing here changes what a sheet does or how it looks; iOS never fires a hardware Back.
const handlers: Array<() => void> = [];

export function registerBackHandler(handler: () => void): () => void {
  handlers.push(handler);
  return () => {
    const index = handlers.lastIndexOf(handler);
    if (index >= 0) handlers.splice(index, 1);
  };
}

// Run the topmost overlay's close. Returns false when no overlay is open (the caller then treats
// Back as screen navigation).
export function handleOverlayBack(): boolean {
  const top = handlers[handlers.length - 1];
  if (!top) return false;
  top();
  return true;
}

export function openOverlayCount(): number {
  return handlers.length;
}

// Overlays call this with their close callback; `active` lets a component that renders nothing
// while closed (the drawer) stay registered only while open.
export function useBackHandler(onClose: () => void, active: boolean = true): void {
  useEffect(() => {
    if (!active) return undefined;
    return registerBackHandler(onClose);
  }, [onClose, active]);
}
